import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import PleaseWait from '../PleaseWait';
import TableRow from './TableRow';

export default class BidReviewsSummaryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: [],
        };

        this.fetchData = this.fetchData.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.show !== prevProps.show && this.props.show) {
            this.fetchData(this.props.competitionId);
        }
    }

    fetchData(competitionId) {
        const url = `/competitions/bid-reviews/${competitionId}`;

        this.setState({loading: true}, () => {
            axios
                .get(url)
                .then((response) => {
                    this.setState({
                        loading: false,
                        data: response.data,
                    });
                });
        });
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onClose} bsSize="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_bid_reviews.reviewers_opinions}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PleaseWait show={this.state.loading}/>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover">
                            <thead>
                            <tr>
                                <th>{window.__js_bid_reviews.reviewer}</th>
                                <th>{window.__js_bid_reviews.documents_stage}</th>
                                <th>{window.__js_bid_reviews.technical_bid_stage}</th>
                                <th>{window.__js_bid_reviews.financial_bid_stage}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.data.length === 0
                                    ? <tr>
                                        <td colSpan={4}>
                                            <em>{window.__js_bid_reviews.no_reviewers_set}</em>
                                        </td>
                                    </tr>
                                    : null
                            }
                            {this.state.data.map((item) => <TableRow key={item.assessor.id} data={item}/>)}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClose}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}